import { EXPORT_REPORT_TRC_API, UPDATE_TRC_STATUS_API } from "../../constants/api";
import { TableRowData } from "../../types/dataType";
import axios from "../fetch/fetch";

export const exportReportForTRCAPI = async (
    failedTRCs: any,
    time: string,
    kpi: {
        KPI: string;
        passed: number;
        total: number;
    }
): Promise<TableRowData> => {
    const body = {
        failedTrc: failedTRCs,
        time: time,
        kpi,
    };
    const res = await axios.post(EXPORT_REPORT_TRC_API, body);
    return res.data;
};
